import { cn } from "@omni/utils/styles";
import { RefObject } from "react";

import {
    useBreakpoint,
    withBreakpoints
} from "@/utils/breakpoints/breakpoints.provider";

import { StoreSearchControls } from "./components/controls/storeSearchControls.container";
import { StoreSearchListComponent } from "./components/list/storeSearchList.component";
import { StoreSearchMapContainer } from "./components/map/storeSearchMap.container";
import { useStoreSearchContext } from "./storeSearch.context";

type StoreSearchComponentProps = {
    mapElementRef: RefObject<HTMLDivElement | null>;
};

const _StoreSearchComponent = ({
    mapElementRef
}: StoreSearchComponentProps) => {
    const { breakpoints } = useBreakpoint();

    const { tab } = useStoreSearchContext();

    return breakpoints.md ? (
        <article
            className={cn(
                "tw:my-4 tw:h-[80vh] tw:max-h-200 tw:flex tw:rounded-md tw:gap-2"
            )}
        >
            <section className={cn("tw:h-full tw:flex tw:flex-col")}>
                <StoreSearchControls />
                <StoreSearchListComponent />
            </section>
            <section className={cn("tw:w-full")}>
                <StoreSearchMapContainer ref={mapElementRef} />
            </section>
        </article>
    ) : (
        <article
            className={cn(
                "tw:my-4 tw:h-[80vh] tw:max-h-200 tw:flex tw:rounded-md tw:flex-col"
            )}
        >
            <StoreSearchControls />
            <div className={cn("tw:h-full tw:flex tw:overflow-hidden")}>
                <section
                    className={cn(
                        "tw:transition-transform tw:min-w-full tw:min-h-full tw:h-full tw:flex tw:flex-col",
                        {
                            "tw:translate-x-0": tab === "list",
                            "tw:-translate-x-full": tab === "map"
                        }
                    )}
                >
                    <StoreSearchListComponent />
                </section>
                <section
                    className={cn(
                        "tw:transition-transform tw:min-w-full tw:min-h-full",
                        {
                            "tw:-translate-x-full": tab === "map"
                        }
                    )}
                >
                    <StoreSearchMapContainer ref={mapElementRef} />
                </section>
            </div>
        </article>
    );
};

export const StoreSearchComponent = withBreakpoints(_StoreSearchComponent);
